import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import useDebounce from "../hooks/useDebounce";
import { cronExpState } from "../selector";
import { cronExpInputState, isAdminState } from "../store";

const useStyles = makeStyles({
	cron: {
		marginRight: "6px",
		backgroundColor: "#382B5F",
		color: "white",
		"& input:focus + fieldset": {
			borderWidth: 0,
			borderColor: "#382B5F",
		},
	},
	input: {
		minWidth: "100px",
		maxWidth: "200px",
		color: "white",
		wordSpacing: "5px",
	},
	label: {
		color: "white",
	},
});

export default function CronExp() {
	const classes = useStyles();

	const isAdmin = useRecoilValue(isAdminState);

	const [cronExp, setCronExp] = useRecoilState(cronExpState);

	const [cronExpInput, setCronExpInput] = useRecoilState(cronExpInputState);

	const debouncedCronExpInput = useDebounce(cronExpInput, 500);

	React.useEffect(() => {
		setCronExpInput(cronExp);
	}, [cronExp]);

	React.useEffect(() => {
		if (debouncedCronExpInput) {
			setCronExp(cronExpInput);
		}
	}, [debouncedCronExpInput]);

	return (
		<Box display="flex" p={1} m={1} style={{ display: "none" }}>
			<TextField
				variant="outlined"
				value={cronExpInput}
				onChange={(event) => {
					setCronExpInput(event.target.value);
				}}
				label=""
				className={classes.cron}
				slotProps={{
					input: {
						classes: {
							input: classes.input,
						},
					},
				}}
				disabled={!isAdmin}
			/>
		</Box>
	);
}
